<template>
    <div v-if="visible" class="popup-upgrade-root">
        <div class="popup-upgrade modal-dialog modal-dialog-centered popup-main-2" role="document" ref="dialog">
            <div class="modal-content box-shadow-main" style="padding: 20px 10px 30px;">
                <button v-if="!forceShow" class="close-popup" @click="close"></button>
                <h3 class="popup-title mb-20">{{ $t('popup_upgrade_acc_title') }}</h3>
                <p class="txt-popup">{{ $t('popup_upgrade_acc_content') }}</p>

                <div v-if="doPlacementTest">
                    <div class="ito-btn-small active mt-3" style="width: 160px; margin: auto" @click="doTest">
                        {{ $t('upgrade_account') }}
                    </div>
                </div>
                <router-link v-else :to="{ path: '/upgrade-account' }" @click.native="handleLinkClick">
                    <div class="ito-btn-small active mt-3" style="width: 160px; margin: auto">
                        {{ $t('upgrade_account') }}
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PopupUpgradeAccount',
    props: {
        forceShow: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        visible() {
            return this.$store.state.showUpgradePopup;
        },
        user_info() {
            return this.$store.state.user_info;
        },
        doPlacementTest() {
            return this.user_info.placement_test === 0 && this.user_info.student_type !== 1;
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    try {
                        this.showBackdrop();
                        document.body.classList.add('modal-open');
                        const btn = this.$el && this.$el.querySelector('.ito-btn-small') || this.$refs.dialog;
                        if (btn && btn.focus) btn.focus();
                    } catch (e) {
                        console.error('PopupUpgradeAccount: showBackdrop error', e);
                    }
                });
            } else {
                try {
                    this.removeBackdrop();
                    document.body.classList.remove('modal-open');
                } catch (e) {
                    console.error('PopupUpgradeAccount: removeBackdrop error', e);
                }
            }
        },
        forceShow(newVal) {
            if (newVal && this.visible) {
                this.$nextTick(() => {
                    try {
                        this.showBackdrop();
                        document.body.classList.add('modal-open');
                    } catch (e) {
                        console.error('PopupUpgradeAccount: forceShow backdrop error', e);
                    }
                });
            }
        }
    },
    methods: {
        close() {
            if (this.forceShow) return;
            this.$store.dispatch('setShowUpgradePopup', false);
        },
        doTest() {
            this.$store.dispatch('setShowUpgradePopup', false);
            this.$store.dispatch('setShowPlacementModalFlag', true);
        },
        handleLinkClick() {
            if (!this.forceShow) {
                this.close();
            }
        },
        showBackdrop() {
            if (document.getElementById('popupUpgradeBackdrop')) return;
            const backdrop = document.createElement('div');
            backdrop.id = 'popupUpgradeBackdrop';
            backdrop.className = 'modal-backdrop fade show';
            backdrop.style.zIndex = '20000';
            if (!this.forceShow) {
                backdrop.addEventListener('click', this.close);
            }
            document.body.appendChild(backdrop);
            if (this.$el) this.$el.style.zIndex = '20001';
        },
        removeBackdrop() {
            const el = document.getElementById('popupUpgradeBackdrop');
            if (el) {
                if (!this.forceShow) {
                    el.removeEventListener('click', this.close);
                }
                document.body.removeChild(el);
            }
            if (this.$el) this.$el.style.zIndex = null;
        }
    }
}
</script>

<style scoped>
.popup-upgrade-root {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 20001;
    pointer-events: none;
}

.popup-upgrade {
    pointer-events: auto;
    z-index: 20002;
}

.modal-backdrop.fade.show {
    background-color: rgba(0, 0, 0, 0.6);
}
</style>
